<template>
  <div class="animated fadeIn">

    <b-card>
      <h2>My Account</h2>
      <div class="lead">Update your profile details or change your subscription plan</div>
    </b-card>

    <b-row class="mt-3">
      <b-col :lg="6">
        <account-subscription @subscription-changed="(sub) => $refs.billing.subscriptionChanged(sub)" />
        <billing-details ref="billing" />
      </b-col>
      <b-col :lg="6">
        <account-details />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Avatar from 'vue-avatar'
import AccountDetails from './account/Details'
import BillingDetails from './account/Billing'
import AccountSubscription from './account/Subscription'

export default {
  name: 'Account',

  components: {
    Avatar,
    AccountDetails,
    BillingDetails,
    AccountSubscription
  }
};
</script>
